// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--sticky-header-height:8.75rem;--environment-footer-height:2 * 1.25rem}.padded-container__container{padding-top:1.25rem;padding-bottom:1.25rem}.padded-container__container--horizontally-padded{padding-left:1.25rem;padding-right:1.25rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
